import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AuthUser, LoginPayload, GoogleLoginPayload } from "./types";

interface AsyncState<T> {
  data: T | null;
  saving: boolean;
  error: boolean;
}

export interface LoginState {
  login: AsyncState<AuthUser>;
  googleLogin: AsyncState<AuthUser>;
}

export const initialState: LoginState = {
  login: { data: null, saving: false, error: false },
  googleLogin: { data: null, saving: false, error: false },
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    saveLogin(state, _action: PayloadAction<LoginPayload>) {
      state.login.saving = true;
      state.login.error = false;
    },
    loginSaved(state, { payload }: PayloadAction<AuthUser>) {
      state.login.data = payload;
      state.login.saving = false;
      state.login.error = false;
    },
    loginSavingError(state) {
      state.login.saving = false;
      state.login.error = true;
    },

    sessionRestored(state, { payload }: PayloadAction<AuthUser>) {
      state.login.data = payload;
    },

    sessionCleared() {
      return initialState;
    },

    userProfileUpdated(
      state,
      {
        payload,
      }: PayloadAction<{ full_name?: string; profile_pic_url?: string | null }>,
    ) {
      if (state.login.data) {
        if (payload.full_name !== undefined)
          state.login.data.full_name = payload.full_name;
        if (payload.profile_pic_url !== undefined)
          state.login.data.profile_pic_url = payload.profile_pic_url;
      }
      if (state.googleLogin.data) {
        if (payload.full_name !== undefined)
          state.googleLogin.data.full_name = payload.full_name;
        if (payload.profile_pic_url !== undefined)
          state.googleLogin.data.profile_pic_url = payload.profile_pic_url;
      }
    },

    saveGoogleLogin(state, _action: PayloadAction<GoogleLoginPayload>) {
      state.googleLogin.saving = true;
      state.googleLogin.error = false;
    },
    googleLoginSaved(state, { payload }: PayloadAction<AuthUser>) {
      state.googleLogin.data = payload;
      state.googleLogin.saving = false;
      state.googleLogin.error = false;
    },
    googleLoginSavingError(state) {
      state.googleLogin.saving = false;
      state.googleLogin.error = true;
    },
  },
});

export const {
  saveLogin,
  loginSaved,
  loginSavingError,
  sessionRestored,
  sessionCleared,
  userProfileUpdated,
  saveGoogleLogin,
  googleLoginSaved,
  googleLoginSavingError,
} = loginSlice.actions;

export const { reducer } = loginSlice;
